import { useState } from "react";
import { Run } from "./Run";
import { createEntityStore } from "../../common/entityStore";
import { Grid } from "@mui/material";
import { propDateField, propFileField } from "../../common/entityStoreForm";
import { propRequired, propValidValue, propValueValidator } from "../../common/entityStoreValidators";
import { useSimpleDialog, yesNoButtons } from "../../common/dialog";
import { today } from "../../common/utils";

export function PaymentRunPage() {
    const [useParamsStore] = useState(() => createEntityStore<RunParams>({
        data: { payDate: today() },
        id: null,
        propValidators: [
            propRequired("file"),
            propValidValue("payDate", "payDateFormatted"),
            propRequired("payDate"),
            propValueValidator("isFileImported", p => p && "File is already imported."),
        ]
    }));
    const simpleDialog = useSimpleDialog();
    async function checkData(callSignalrMethod: <T>(name: string) => Promise<{ success: boolean; result: T; }>) {
        const { result: alreadyImportedRate } = await callSignalrMethod<number>("initialCheck");
        return await new Promise<boolean>(resolve => {
            if (alreadyImportedRate == null) {
                resolve(false);
            } else if (alreadyImportedRate < 0.4) {
                resolve(true);
            } else {
                simpleDialog.show("Duplicate payment file",
                    `${Math.round(alreadyImportedRate * 100)}% of payments are already in the database. Do you want to continue?`,
                    () => resolve(false), yesNoButtons(() => {
                        resolve(true);
                    }));
            }
        });
    }
    const [isRunning, setIsRunning] = useState(false);
    function renderParams() {
        return <>
            <Grid item xs={12}>{propFileField(useParamsStore)("file", "File", { disabled: isRunning, onChange: () => useParamsStore.getState().setClientDataProp("isFileImported", undefined) })}</Grid>
            <Grid item xs={12}>{propDateField(useParamsStore)("payDate", "payDateFormatted", "Date")}</Grid>
        </>;
    }
    return <>
        {simpleDialog.render()}
        <Run name="Batch payments" hub="paymentRun" checkData={checkData} onRunFinished={p => p && useParamsStore.getState().setClientDataProp("isFileImported", true)}
            useParamsStore={useParamsStore} renderParams={renderParams} setIsRunning={setIsRunning} />
    </>;
}

interface RunParams {
    file?: File;
    isFileImported?: boolean;
    payDate?: string;
    payDateFormatted?: string;
}
